import { IconCirclePlus } from '@tabler/icons-react'
import React from 'react'

const IconButton = ({ icon, text, onClickFunction, cssClass = "" }) => {
    return (
        <button className={`border border-1 border-[#ECECF2] flex items-center !px-3 !py-2 rounded-lg text-sm text-[#686C8F] font-semibold gap-2 ${cssClass}`}
            onClick={onClickFunction && (() => onClickFunction())} >
            <span className='text-[#3B3C51]'>
                {icon ?? <IconCirclePlus />}
            </span>
            {text && <span className='hidden md:block'>{text ?? null}</span>}
        </button>
    )
}

export default IconButton